export function convertPolygonToPath(points: number[][][]): google.maps.LatLngLiteral[] {
    return points[0].map(pt => ({ lat: pt[1], lng: pt[0]}));
}

export function convertPathToPolygon(path: google.maps.LatLngLiteral[]): number[][][] {
    const points = path.map(x => [x.lng, x.lat]);
    return [points];
}